import React from 'react';

function SettingBooleano({
    value,
    trueButtonClass,
    falseButtonClass,
    trueElement,
    falseElement,
    setTrue,
    setFalse,
    customValueTrue,
    customValueFalse
}) {

    if (customValueTrue && value === customValueTrue) {
        value = true
    } else if (customValueFalse && value === customValueFalse) {
        value = false
    }

    if (value) {
        return (
            <button className={trueButtonClass} onClick={setFalse}>
                {trueElement}
            </button>)
    } else {
        return (
            <button className={falseButtonClass} onClick={setTrue}>
                {falseElement}
            </button>)
    }
}

export default SettingBooleano;